import { Box, Icon, IconButton, type SxProps, type Theme, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { BodyTextSmall } from "~/components/Typographies";
import { useSnacks } from "~/providers/SnackProvider";

interface CopyResultLineProps {
	copyText?: string;
	text: string;
	textSx?: SxProps<Theme>;
}

const CopyResultLine = ({ copyText, text, textSx }: CopyResultLineProps) => {
	const { t } = useTranslation("common");
	const [openSnack] = useSnacks();

	const copy = async () => {
		await navigator.clipboard.writeText(copyText ?? text);
		openSnack(t("shared.copiedToClipboard"), "success");
	};

	return (
		<Box
			sx={{
				alignItems: "center",
				backgroundColor: "action.hover",
				border: "1px solid",
				borderColor: "divider",
				borderRadius: 1,
				display: "flex",
				gap: 0.5,
				pl: 1.5,
				pr: 0.5,
				py: 0.5
			}}
		>
			<BodyTextSmall sx={{ flex: 1, whiteSpace: "pre-line", ...textSx }}>{text}</BodyTextSmall>
			<Tooltip title={t("actions.copy")}>
				<IconButton aria-label={t("actions.copy")} onClick={copy} size="small">
					<Icon sx={{ fontSize: "1.05rem" }}>content_copy</Icon>
				</IconButton>
			</Tooltip>
		</Box>
	);
};

export default CopyResultLine;
